import { Navigate, useParams } from 'react-router-dom'
import { useAuth } from '../../hooks/useAuth'
import { isAddonLoaded, useActiveAddons } from './addonRegistry'
import AddonErrorBoundary from './AddonErrorBoundary'

// The page an add-on's sidebar entry opens, at /addons/<key>. Someone who does not have it is sent
// home without being told anything, the same as the server answering 404 for them.
export default function AddonPage() {
  const { key } = useParams()
  const { user } = useAuth()
  const active = useActiveAddons()
  if (user?.addons?.[key] !== true) return <Navigate to="/dashboard" replace />
  const Page = active.find((a) => a.key === key)?.mod?.page
  if (!Page) {
    return <div className="p-6 text-sm text-gray-500">{isAddonLoaded(key) ? 'Nothing to show here.' : 'Loading…'}</div>
  }
  return (
    <div className="p-6">
      <AddonErrorBoundary addon={key}><Page /></AddonErrorBoundary>
    </div>
  )
}
